module.exports = __webpack_public_path__ + "static/media/airplane-r.3e329779.svg";